
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ConfigChangeType enum
 */
class ConfigChangeType {
  /**
   * Initialize enum with a given value
   * @param {ConfigChangeType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ConfigChangeType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ConfigChangeType}
   * @param {!ConfigChangeType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ConfigChangeType)) {
      throw new TypeError('Instance of ConfigChangeType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ConfigChangeType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ConfigChangeType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ConfigChangeType.CREATE.value) {
      return 'CREATE'
    }
    if (this.value === ConfigChangeType.UPDATE.value) {
      return 'UPDATE'
    }
    if (this.value === ConfigChangeType.DELETE.value) {
      return 'DELETE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ConfigChangeType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ConfigChangeType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ConfigChangeType} Created enum
   */
  static fromObject (other) {
    return new ConfigChangeType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ConfigChangeType.CREATE = new ConfigChangeType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ConfigChangeType.UPDATE = new ConfigChangeType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ConfigChangeType.DELETE = new ConfigChangeType(0 + 2)

export { ConfigChangeType };

/**
 * Fast Binary Encoding ConfigChangeType field model
 */
class FieldModelConfigChangeType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelConfigChangeType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelConfigChangeType}
   * @param {ConfigChangeType=} defaults Default value, defaults is new ConfigChangeType()
   * @returns {!ConfigChangeType} Result value
   */
  get (defaults = new ConfigChangeType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ConfigChangeType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelConfigChangeType}
   * @param {!ConfigChangeType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelConfigChangeType };
